import { useDashboardV2Enabled } from "src/hooks/useDashboardV2Enabled";
import DashboardAppNew from "./DashboardAppNew";
import DashboardAppV2 from "./DashboardAppV2";

// Chooses which dashboard to show for the logged-in user. The per-company
// setting (Company → Settings) is authoritative, with a ?dashboard=v2 / v1
// live preview override — both resolved by useDashboardV2Enabled, the single
// source of truth also used to gate the other V2-only UI.
const DashboardSwitch = () => {
  const showV2 = useDashboardV2Enabled();
  return showV2 ? <DashboardAppV2 /> : <DashboardAppNew />;
};

export default DashboardSwitch;
